import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Footer from './components/Footer';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import HomePage from './pages/HomePage';
import profileImage from './assets/profile-image.jpg';

// Centralized personal information
const personalInfo = {
  name: "Julian Streibel",
  email: "julian@streibel.xyz",
  company: "Stealth Startup", 
  position: "MTS - Machine Learning",
  education: "M.Sc. Computer Science",
  birthdate: "29.08.97",
  location: "Vienna, Austria",
  image: profileImage,
};

const links = [
  { name: "GitHub", url: "https://github.com/julianstreibel", isExternal: true },
  { name: "LinkedIn", url: "https://linkedin.com/in/julian-streibel-482346207", isExternal: true },
  { name: "Email", url: `mailto:${personalInfo.email}`, isExternal: false }
];

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route 
            path="/" 
            element={<HomePage personalInfo={personalInfo} links={links} />} 
          />
          <Route 
            path="/impressum" 
            element={
              <Impressum 
                name={personalInfo.name}
                address={personalInfo.address}
                city={personalInfo.city}
                postalCode={personalInfo.postalCode}
                phone={personalInfo.phone}
                email={personalInfo.email}
              />
            } 
          />
          <Route 
            path="/datenschutz" 
            element={
              <Datenschutz 
                name={personalInfo.name}
                address={personalInfo.address}
                city={personalInfo.city}
                postalCode={personalInfo.postalCode}
                phone={personalInfo.phone}
                email={personalInfo.email}
              />
            }
          />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
